import React, {FC, useState} from "react";
import Link from "next/link";
import {useSelector} from "react-redux";
import {IState} from "../../types/state";
import {ordersType} from "./types";
import cls from "./account.module.scss"
import Pagination from "../shared/Pagination";
import {TranslationsType} from "../../types/homePageTypes";

const AccountPageOrders: FC<{ translationsData: TranslationsType }> = ({translationsData}) => {
    const limit = 10;
    const [page, setPage] = useState<number>(1);
    const orders = useSelector((state: IState) => state.orders.all);
    const totalPages = Math.ceil(orders.length / limit);
    const paginatedOrders = orders.slice((page - 1) * limit, page * limit);

    const handlePageChange = (page: React.SetStateAction<number>) => {
        setPage(page);
    };

    if (!orders) return null;

    function formatDate(date: string) {
        let cleared = date.split("-");
        let year = cleared[0];
        let month = cleared[1];
        let day = cleared[2].slice(0, 2);
        return day + "/" + month + "/" + year;
    }

    const orderStatusColor = (status: string) => {
        switch (status) {
            case ("closed"):
                return "#D71313";
            case("canceled"):
                return "#D71313";
            case("processing"):
                return "#ff6c22";
            case("pending"):
                return "#f4ce14";
            case("completed"):
                return "#049901";
            default:
                return "#000"
        }
    }

    const ordersList = paginatedOrders.map((order: ordersType) => {
        let date = formatDate(order.created_at);
        const statusIdKey = order.status.replace(order.status[0], order.status[0].toUpperCase())
        return (
            <tr key={order.id}>
                <td className={cls.first_column}>
                    <Link href={`/account/orders/[orderId]`} as={`/account/orders/${order.id}`}>
                        <a className={cls.underline}>{`#${order.id}`}</a>
                    </Link>
                </td>
                <td>{date}</td>
                <td>{order.formated_sub_total}</td>
                <td>{order.formated_tax_amount}</td>
                <td>{order.formated_shipping_amount}</td>
                {
                    // TODO !!! after test currency amount remove!
                    // order.formated_base_discount_amount !== "$0.00" ? (
                    //         <td>{order.formated_base_discount_amount}</td>
                    order.formated_discount_amount !== "$0.00" ? (
                        <td>{order.formated_discount_amount}</td>
                    ) : (
                        <td>$0.00</td>
                    )
                }
                <td>{order.formated_grand_total || 0}</td>
                <td style={{color: orderStatusColor(order?.status.toLowerCase())}} className={cls.last_column}>
                    {" "}
                    {translationsData[statusIdKey]}
                </td>
            </tr>
        );
    });

    const mobileOrderList = paginatedOrders.length > 0 ? paginatedOrders.map((order: ordersType) => {
            const statusIdKey = order.status.replace(order.status[0], order.status[0].toUpperCase())
            let date = formatDate(order.created_at);
            return (
                <div key={order.id} className={`${cls.card} ${cls["order-history-card-mobile"]}`}>
                    <div className={cls["order-card-mobile-top-position"]}>
                        <tr>
                            <td className={cls["order-card-mobile-title"]}>
                                <th style={{textTransform: "uppercase"}}>
                                    {translationsData.OrderId}
                                </th>
                                <td>
                                    <Link href={`/account/orders/${order.id}`}>
                                    <span className={cls["order-id-mobile-href"]}>
                                        {`#${order.id}`}
                                    </span>
                                    </Link>
                                </td>
                            </td>
                        </tr>
                        <tr>
                            <td className={cls["order-card-mobile-title"]} style={{justifyContent: "space-between"}}>
                                <th>
                                    {translationsData.Total}
                                </th>
                                <td>
                                    {order.formated_grand_total || 0}
                                </td>
                            </td>
                        </tr>
                    </div>

                    <table>
                        <div className={cls.table_column}>
                            <tr className={cls["order-card-mobile-options"]}>
                                <th>
                                    {translationsData.Date}
                                </th>
                                <td>{date}</td>
                            </tr>
                            <tr>
                                <th>
                                    {translationsData.Tax}
                                </th>
                                <td>{order.formated_tax_amount}</td>
                            </tr>
                            <tr>
                                <th>
                                    {translationsData.Discount}
                                </th>
                                <td>{order.formated_base_discount_amount}</td>
                            </tr>
                        </div>
                        <div className={cls.table_column}>
                            <tr>
                                <th>
                                    {translationsData.Price}
                                </th>
                                <td>{order.formated_sub_total}</td>
                            </tr>
                            <tr>
                                <th>
                                    {translationsData.Shipping}
                                </th>
                                <td>{order.formated_shipping_amount}</td>
                            </tr>
                            <tr>
                                <th>
                                    {translationsData.Status}
                                </th>
                                <td style={{color: orderStatusColor(order?.status.toLowerCase())}}>
                                    {translationsData[statusIdKey]}
                                </td>
                            </tr>
                        </div>
                    </table>
                </div>
            );
        })
        : <span className={cls.empty_orders_list}>{translationsData.OrderListEmpty}</span>


    return (
        <>
            <div className={cls.card_desktop}>
                <div className={cls.card}>
                    {
                        paginatedOrders.length > 0 ?
                            <div className={cls["card-table"]}>
                                <table>
                                    <thead>
                                    <tr>
                                        <th className={cls.first_column}>
                                            {translationsData.OrderId}
                                        </th>
                                        <th>
                                            {translationsData.Date}
                                        </th>
                                        <th>
                                            {translationsData.Price}
                                        </th>
                                        <th>
                                            {translationsData.Tax}
                                        </th>
                                        <th>
                                            {translationsData.Shipping}
                                        </th>
                                        <th>
                                            {translationsData.Discount}
                                        </th>
                                        <th>
                                            {translationsData.Total}
                                        </th>
                                        <th className={cls.last_column}>
                                            {translationsData.Status}
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>{ordersList}</tbody>
                                </table>
                            </div>
                            : <span className={cls.empty_orders_list}>{translationsData.OrderListEmpty}</span>
                    }
                </div>
                <div className={cls["card-footer"]}>
                {
                    totalPages > 1 && <Pagination
                            current={page}
                            total={totalPages}
                            onPageChange={handlePageChange}
                        />
                    }
                </div>
            </div>

            <div className={cls.card_mobile}>
                <div className={cls["orders-page-mobile"]}>
                    {mobileOrderList}
                </div>
                <div className={cls["card-footer"]}>
                    {
                        totalPages > 1 && <Pagination
                            current={page}
                            total={totalPages}
                            onPageChange={handlePageChange}
                        />
                    }
                </div>
            </div>
        </>
    )
};

export default AccountPageOrders;
